<template>
	<div>
		<compWrapper title="基本信息" theme="primary">
			<compFormQuery v-if="type==='query'" class="margin-top-15" :formdata="getBase" :value="formData"></compFormQuery>
            <compFormEdit v-else ref="formbase" class="margin-top-15" :formdata="getBase" v-model="formData"></compFormEdit>
		</compWrapper>
        <compWrapper  title="接口信息" theme="primary">
			<compFormQuery v-if="type==='query'" class="margin-top-15" :formdata="getApi" :value="formData"></compFormQuery>
            <compFormEdit v-else ref="formbase" class="margin-top-15" :formdata="getApi" v-model="formData"></compFormEdit>
		</compWrapper>
        <compLog v-if="type==='query'" wrapper :data="logList"></compLog>
		<div v-if="type!='query'" class="text-right margin-top-10">
			<vButton theme="primary" @click="submit">保存</vButton>
			<vButton class="margin-left-10" @click="onCancel">返回</vButton>
		</div>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpQueryServiceManageOne, HttpSaveServiceManageOne } from '@/service/credit';
import {HttpInboundOrderLogList } from "@/service/inbound";
import { mapGetters } from "vuex";
export default {
	props:['querytype','activeid'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		compLog: () => import("@components/templates/log")
	},
	data() {
		return {
            type: this.querytype || this.$route.params.type,
            id: this.activeid || this.$route.query.id,
			logList: [],
			loading: false,
			formData: {
			}
		};
	},
	created() {
		this.getDetail();
        if(this.type == 'query'){
            // 请求日志的接口
            HttpInboundOrderLogList({ 'search[EQ_orderType]': 9004, 'search[EQ_orderId]': this.id }).then(res => {
				this.logList = res.data;
			}).catch(err => {
				this.loading = false;
				this.$Message.error(err.message);
			})
        }
	},
	computed: {
		getBase() {
			return [
                {
                    label: "服务商名称",
                    key: "providerName",
					tag: "vInput",
                },
                {
                    label: "服务商编码",
                    key: "providerCode",
					tag: "vInput",
                },
			];
		},
        getApi(){
            return [
                {
                    label: "apiUrl",
                    key: "apiUrl",
					tag: "vInput",
                },
                {
                    label: "appKey",
                    key: "appKey",
					tag: "vInput",
                },
                {
                    label: "appSecret",
                    key: "appSecret",
					tag: "vInput",
                },
			];
        },
	},
	methods: {
		onCancel() {
			this.$router.push({
				name: "rulesServicemanageList"
			});
		},
		cancel() {
			this.$emit('on-close')
		},
		getDetail() {
			if (this.type === "add") return;
			this.loading = true;
			HttpQueryServiceManageOne({
				serviceProviderId: this.id,
			}).then(res => {
                const data = res.data || {};
				this.formData = data;
                let providerMeta = JSON.parse(res.data.providerMeta)
                this.formData.apiUrl = providerMeta.apiUrl;
                this.formData.appKey = providerMeta.appKey;
                this.formData.appSecret = providerMeta.appSecret;

				this.loading = false;
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			});
		},
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
            let providerMeta = {
                apiUrl:this.formData.apiUrl,
                appKey:this.formData.appKey,
                appSecret:this.formData.appSecret,
            }
            delete this.formData.apiUrl;
            delete this.formData.appKey;
            delete this.formData.appSecret;
            this.formData.providerMeta = JSON.stringify(providerMeta)
			this.loading = true;
			HttpSaveServiceManageOne({
				id: this.id,
                orgId:global.SYSID,
                ...this.formData,
			}).then(res => {
				this.loading = false;
				this.onCancel();
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
	}
};
</script>
